!(function (e) {
  var t,
    n,
    o,
    i,
    c,
    a =
      '<svg><symbol id="icon-dayuhao" viewBox="0 0 1024 1024"><path d="M798.38 538.03l-575.1-346.2 0.04-68.75 575.04 345.6 0.02 69.35z"  ></path><path d="M798.38 538.03L223.3 894.99v-69.52l575.06-356.79 0.02 69.35z"  ></path></symbol><symbol id="icon-user" viewBox="0 0 1024 1024"><path d="M858.5 763.6c-18.9-44.8-46.1-85-80.6-119.5-34.5-34.5-74.7-61.6-119.5-80.6-0.4-0.2-0.8-0.3-1.2-0.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-0.4 0.2-0.8 0.3-1.2 0.5-44.8 18.9-85 46-119.5 80.6-34.5 34.5-61.6 74.7-80.6 119.5C146.9 807.5 137 854 136 901.8c-0.1 4.5 3.5 8.2 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c0.1 4.4 3.6 7.8 8 7.8h60c4.5 0 8.1-3.7 8-8.2-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"  ></path></symbol><symbol id="icon-lianxi" viewBox="0 0 1210 1024"><path d="M186.181818 74.472727A111.709091 111.709091 0 0 0 74.472727 186.181818v651.636364A111.709091 111.709091 0 0 0 186.181818 949.527273h837.818182a111.709091 111.709091 0 0 0 111.709091-111.709091V186.181818A111.709091 111.709091 0 0 0 1024 74.472727H186.181818zM186.181818 0h837.818182a186.181818 186.181818 0 0 1 186.181818 186.181818v651.636364a186.181818 186.181818 0 0 1-186.181818 186.181818H186.181818a186.181818 186.181818 0 0 1-186.181818-186.181818V186.181818a186.181818 186.181818 0 0 1 186.181818-186.181818z m266.24 623.010909l-5.352727 0.465455-110.312727-94.254546 2.094545-13.125818 216.064-216.343273L662.202182 409.6l-209.826909 213.457455z m246.737455-250.926545l-111.150546-105.518546 78.522182-78.615273 32.116364-1.675636 80.011636 79.732364-4.887273 30.161454-74.612363 75.869091z m-395.450182 304.919272l-24.064 8.052364 9.634909-35.002182 31.604364-75.869091 76.101818 62.557091-93.277091 40.261818z m6.190545 53.573819h544.349091c16.616727 0.046545 30.114909 13.498182 30.114909 30.161454v0.093091c0 16.616727-13.498182 30.114909-30.114909 30.114909H309.899636a30.254545 30.254545 0 0 1 0-60.369454z m544.023273-75.496728h-301.847273a30.394182 30.394182 0 1 1 0-60.834909h301.847273a30.440727 30.440727 0 0 1 0 60.834909z"  ></path></symbol></svg>',
    d = (d = document.getElementsByTagName("script"))[
      d.length - 1
    ].getAttribute("data-injectcss"),
    l = function (e, t) {
      t.parentNode.insertBefore(e, t);
    };
  if (d && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;
    try {
      document.write(
        "<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>"
      );
    } catch (e) {
      console && console.log(e);
    }
  }
  function s() {
    c || ((c = !0), o());
  }
  function m() {
    try {
      i.documentElement.doScroll("left");
    } catch (e) {
      return void setTimeout(m, 50);
    }
    s();
  }
  (t = function () {
    var e, t;
    ((t = document.createElement("div")).innerHTML = a),
      (a = null),
      (e = t.getElementsByTagName("svg")[0]) &&
        (e.setAttribute("aria-hidden", "true"),
        (e.style.position = "absolute"),
        (e.style.width = 0),
        (e.style.height = 0),
        (e.style.overflow = "hidden"),
        (t = e),
        (e = document.body).firstChild ? l(t, e.firstChild) : e.appendChild(t));
  }),
    document.addEventListener
      ? ~["complete", "loaded", "interactive"].indexOf(document.readyState)
        ? setTimeout(t, 0)
        : ((n = function () {
            document.removeEventListener("DOMContentLoaded", n, !1), t();
          }),
          document.addEventListener("DOMContentLoaded", n, !1))
      : document.attachEvent &&
        ((o = t),
        (i = e.document),
        (c = !1),
        m(),
        (i.onreadystatechange = function () {
          "complete" == i.readyState && ((i.onreadystatechange = null), s());
        }));
})(window);
